import React from 'react';
import classNames from 'classnames';

const HangingTag = ({ label = '', animated = false, mobileView = false }) => {
  const classes = classNames('ws-ui-hanging-tag', {
    'ws-ui-hanging-tag--mobile': mobileView,
    'ws-ui-hanging-tag--desktop': !mobileView,
    'ws-ui-hanging-tag--animated': animated,
  });

  return (
    <div className={classes}>
      <div className="ws-ui-hanging-tag__tag">
        <div className="ws-ui-hanging-tag__label">{label}</div>
      </div>
    </div>
  );
};

export default HangingTag;
